import MemberBenefitInformationBlock from './MemberBenefitInformationBlock';

export default MemberBenefitInformationBlock;
